export class SidebarEntrySchema {
  title: string;
  path?: string;
  href?: string;
  allowed_roles: string[];
  icon: string;
  active?: boolean;
  show?: boolean;
}
